import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './product-overview.css';

const ProductOverview = ({ name, color, size, price, img, miniImg1, miniImg2, miniImg3, miniImg }) => {
	const [ index, setIndex ] = useState(0);
	const [ changeImg, setChangeImg ] = useState(img);

	const [ changeColorIndex, setChangeColorIndex ] = useState(0);

	const handleSlideRight = () => {
		if (index !== changeImg.length - 1) {
			setIndex((prev) => prev + 1);
			return index;
		}
	};
	const handleSlideLeft = () => {
		if (index !== 0) {
			setIndex(index - 1);
			return index;
		}
	};
	return (
		<React.Fragment>
			<div className="product-overview-container">
				<h1 className="current-product-typography">{name}</h1>
				<ul className="product-detail-list-section-one">
					<li>Color: {color[changeColorIndex]}</li>
					<li>Sizes | {size}</li>
					<li>${price}</li>
				</ul>
				<div className="product-section-one">
					<div className="product-info">
						<div className="product-image-carousel-container">
							<div className="product-image-carousel ">
								<FaChevronLeft className="left-arrow" onClick={handleSlideLeft} />
								<img src={changeImg[index]} alt="product" className="product-image-full" />
								<FaChevronRight className="right-arrow" onClick={handleSlideRight} />
							</div>
						</div>
					</div>
					<div className="product-mini-image-container">
						<img
							src={miniImg1[0]}
							alt="product"
							className="product-image-mini"
							onClick={() =>
								setChangeImg(() => {
									setIndex(0);
									setChangeColorIndex(0);
									return miniImg1;
								})}
						/>
						<img
							src={miniImg2[0]}
							alt="product"
							className="product-image-mini"
							onClick={() =>
								setChangeImg(() => {
									setIndex(0);
									setChangeColorIndex(1);
									return miniImg2;
								})}
						/>
						<img
							src={miniImg3[0]}
							alt="product"
							className="product-image-mini"
							onClick={() =>
								setChangeImg(() => {
									setIndex(0);
									setChangeColorIndex(2);
									return miniImg3;
								})}
						/>
						{/* <img src={miniImg2} alt="product" className="product-image-mini" /> */}
						{/* <img src={miniImg3} alt="product" className="product-image-mini" /> */}

						{/* {miniImg1.map((img) => {
							return (
								<img
									src={img}
									alt="product"
									className="product-image-mini"
									onClick={() =>
										setChangeImg(() => {
											setIndex(0);
											return [ img ];
										})}
								/>
							);
						})} */}
					</div>
				</div>
				<div className="product-section-two">
					<h1 className="current-product-typography-two">Product Overview</h1>
					<h3 className="features-typography">Features</h3>
					<hr />
					<ul className="product-features-list">
						<li>Dri-FIT technology helps you stay dry and comfortable.</li>
						<li>Knit fabric feels soft and has plenty of stretch so you can move freely.</li>
						<li>Standard fit for a relaxed, easy feel</li>
						<li>100% polyester</li>
						<li>Machine wash</li>
					</ul>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ProductOverview;
